import type { ShouldRevalidateFunction } from '@remix-run/react';

export const shouldRevalidateLoaderData: ShouldRevalidateFunction = ({
  defaultShouldRevalidate,
  formAction,
  formData,
}) => {
  const isCreatingLogin = formAction === '/create_login';

  const isRequestingMagicLink = formData?.get('request_magic_link') === 'true';

  if (isCreatingLogin && isRequestingMagicLink) {
    return false;
  }

  if (formAction === '/posts_insights' || formAction === '/page_view') {
    return false;
  }

  return defaultShouldRevalidate;
};
